// extracted by mini-css-extract-plugin
var _1 = "OrganizationUsers-module__infiniteScrollWaypoint--bGTfa";
var _2 = "241px";
export { _1 as "infiniteScrollWaypoint", _2 as "itemHeight" }
